import Reveal from "@/components/base/Reveal";
import { values } from "@/mocks/home";

export default function ValuesSection() {
  return (
    <section id="values" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <Reveal className="text-center mb-12 md:mb-16">
          <span className="inline-flex items-center gap-2 text-secondary-600 text-sm font-medium">
            <i className="ri-award-line"></i>
            平台核心价值
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
            四重价值，共生共赢
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-4 max-w-2xl mx-auto leading-relaxed">
            不止于种地，更是产业、生态、社会与人文的深度重构。
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {values.map((value, i) => (
            <Reveal key={value.id} delay={i * 80}>
              <div className="h-full bg-white rounded-lg border border-background-200 p-6 md:p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-accent-300">
                <span className="w-12 h-12 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className={`${value.icon} text-2xl`}></i>
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mt-5">
                  {value.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mt-3">{value.desc}</p>
                <div className="flex flex-wrap gap-1.5 mt-4">
                  {value.points.map((point) => (
                    <span
                      key={point}
                      className="text-xs px-2 py-1 rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap"
                    >
                      {point}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}